import {
  Directive,
  effect,
  ElementRef,
  input,
  Input,
  Renderer2,
} from '@angular/core';

const DRAWER_TRANSITION_MS = 300;

@Directive({
  selector: '[stSideDrawer]',
  standalone: true,
})
export class SideDrawerDirective {
  maxWidth = input<string>();

  @Input() set isOpen(value: boolean) {
    this._isOpen = value;
    if (this._direction) this.toggleDrawer();
  }

  @Input() set direction(value: 'left' | 'right') {
    this._direction = value;
    this.setupDrawer(value);
    this.createBackdrop();
    this.toggleDrawer();
  }

  private _isOpen = false;
  private _direction!: 'left' | 'right';
  private backdrop!: HTMLDivElement;

  constructor(
    readonly el: ElementRef,
    readonly renderer: Renderer2,
  ) {
    effect(() => {
      if (this.maxWidth()) {
        if (this.el) {
          this.renderer.setStyle(
            this.el.nativeElement,
            'width',
            this.maxWidth(),
          );
        }
      }
    });
  }

  private setupDrawer(dir: 'left' | 'right') {
    this.renderer.setStyle(this.el.nativeElement, 'position', 'absolute');
    this.renderer.setStyle(this.el.nativeElement, 'top', '0');
    this.renderer.setStyle(this.el.nativeElement, 'bottom', '0');
    this.renderer.setStyle(this.el.nativeElement, 'z-index', '999');
    this.renderer.setStyle(this.el.nativeElement, 'background', '#FFF');
    this.renderer.setStyle(this.el.nativeElement, dir, '0');
  }

  private toggleDrawer() {
    const hiddenTransform =
      this._direction === 'left' ? 'translateX(-100%)' : 'translateX(100%)';
    const easing = this._isOpen ? 'ease-in' : 'ease-out';

    this.renderer.setStyle(
      this.el.nativeElement,
      'transition',
      `transform ${DRAWER_TRANSITION_MS}ms ${easing}`,
    );
    this.renderer.setStyle(
      this.el.nativeElement,
      'transform',
      this._isOpen ? 'translateX(0)' : hiddenTransform,
    );

    if (this._isOpen) {
      this.showBackdrop();
    } else {
      this.hideBackdrop();
    }
  }

  private createBackdrop() {
    this.backdrop = this.renderer.createElement('div');
    this.renderer.addClass(this.backdrop, 'side-drawer-backdrop');
    this.renderer.setStyle(this.backdrop, 'position', 'absolute');
    this.renderer.setStyle(this.backdrop, 'inset', '0');
    this.renderer.setStyle(this.backdrop, 'z-index', '998');
    this.renderer.setStyle(
      this.backdrop,
      'background-color',
      'rgba(0, 0, 0, 0.3)',
    );
    this.renderer.setStyle(this.backdrop, 'display', 'none');
    this.renderer.appendChild(
      this.el.nativeElement.parentElement,
      this.backdrop,
    );
  }

  private showBackdrop() {
    this.renderer.setStyle(this.backdrop, 'display', 'block');
    setTimeout(() => {
      this.renderer.setStyle(this.backdrop, 'opacity', '0.9');
    });
  }

  private hideBackdrop() {
    this.renderer.setStyle(this.backdrop, 'opacity', '0');
    setTimeout(() => {
      this.renderer.setStyle(this.backdrop, 'display', 'none');
    }, DRAWER_TRANSITION_MS);
  }
}
